import { animateCSS } from '@/libs/animate';
import { t } from '@/libs/i18n';
import { Controller } from '@hotwired/stimulus';
import { useLocalStorage } from '@vueuse/core';

// En un futuro se podrá compartir entre componentes esta configuración
const CONFIGURACION_LISTADOS = 'ge-configuracion-listados';

const SELECTOR_LISTADO = '[data-controller="listado"]';
/**
 * Se trata de el check de mostrar conceptos. Es un check que al marcarlo se muestran los
 * conceptos en el listado, si no está marcado solo mostramos el número de conceptos
 */
export default class extends Controller {
  connect() {
    const check = this.element;
    this.listado = document.querySelector(SELECTOR_LISTADO);

    document.querySelector(SELECTOR_LISTADO)?.addEventListener('listado:updated', () => {
      this.#inicializarContadores();
      this.#cambiarConceptos(check.checked);
    });

    // Cargamos la configuración inicial
    const conf = useLocalStorage(CONFIGURACION_LISTADOS, { mostrarConceptos: false });
    check.checked = conf.value.mostrarConceptos;

    check.addEventListener('change', () => {
      this.#cambiarConceptos(check.checked);
    });
    this.#inicializarContadores();
    this.#cambiarConceptos(check.checked);
  }

  #inicializarContadores() {
    this.listado.querySelectorAll('.conceptos-detalle').forEach((wrapperDetalle) => {
      wrapperDetalle.style.display = 'none';
    });

    this.listado.querySelectorAll('.conceptos-detalle').forEach((wrapperDetalle) => {
      this.#crearContador(wrapperDetalle);
    });
  }

  // eslint-disable-next-line class-methods-use-this
  #crearContador(wrapperDetalle) {
    const wrapperContador = document.createElement('div');
    wrapperContador.classList.add('conceptos-resumen', 'text-center');

    const contador = document.createElement('span');
    contador.classList.add('badge', 'badge-default', 'badge-numero-redondo-sm', 'clickable');
    contador.setAttribute('title', t('mostrar_conceptos'));
    contador.setAttribute('data-toggle', 'tooltip');
    contador.addEventListener('click', () => {
      wrapperContador.style.display = 'none';
      wrapperDetalle.style.display = 'block';
    });
    contador.innerText = wrapperDetalle.children.length;

    wrapperContador.appendChild(contador);
    wrapperDetalle.after(wrapperContador);
  }

  // eslint-disable-next-line class-methods-use-this
  #guardarEstado(mostrarConceptos) {
    const conf = useLocalStorage(CONFIGURACION_LISTADOS, { mostrarConceptos: false });
    conf.value.mostrarConceptos = mostrarConceptos;
  }

  #cambiarConceptos(mostrarConceptos) {
    let classVisible = '.conceptos-resumen';
    let classNoVisible = '.conceptos-detalle';
    if (mostrarConceptos) {
      classVisible = '.conceptos-detalle';
      classNoVisible = '.conceptos-resumen';
    }

    this.listado.querySelectorAll(classVisible).forEach((el) => {
      animateCSS(el, 'fadeIn');
      el.style.display = 'block';
    });
    this.listado.querySelectorAll(classNoVisible).forEach((el) => {
      if (el.style.display !== 'none') {
        // animateCSS(el, 'fadeOut').then(() => {
        el.style.display = 'none';
        // });
      }
    });
    this.#guardarEstado(mostrarConceptos);
  }
}
